import React from 'react';

export function ISDViewerIcon({ size = 22, style, ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 22"
            strokeWidth="2.5"
            height={size}
            width={size}
            style={{ fill: 'currentColor', ...style }}
            {...props}
        >
            <path d="M21.47,8.28l-.25-.18s-.38.5-1.13,1.14c1.05-1.67,1.36-3.15,1.37-3.19l-.3-.06s-.39,1.94-1.82,3.82c0,0-.01.01-.02.02-1.84.57-4.81,1.29-8.14,1.32v-.88h-.25v.88c-3.26-.01-6.2-.71-8.06-1.28-1.47-1.9-1.88-3.81-1.88-3.85l-.3.06s.32,1.51,1.38,3.17c-.76-.65-1.16-1.15-1.17-1.17l-.24.19s.46.58,1.32,1.3c-.74-.25-1.16-.44-1.18-.44l-.12.28s.76.33,2,.71c0,0,.01,0,.02.01,1.5,1.89,4.03,3.74,8.24,3.78v.89h.25v-.88c4.25-.03,6.8-1.9,8.29-3.82,1.19-.37,1.91-.68,1.92-.69l-.12-.28s-.41.18-1.09.41c.85-.71,1.27-1.26,1.28-1.28ZM18.5,10.41c-1.65,1.01-4.06,1.98-7.31,2.06v-1c2.85-.02,5.45-.55,7.31-1.06ZM10.93,12.47c-3.17.03-5.63-.99-7.31-2.06,1.87.52,4.47,1.04,7.31,1.05v1.01ZM3.7,10.82c1.69,1.02,4.07,1.96,7.11,1.96.04,0,.08,0,.13,0v.85c-3.44-.04-5.73-1.31-7.23-2.81ZM11.19,13.63v-.86c3.27-.08,5.72-1.05,7.41-2.07-1.43,1.47-3.75,2.9-7.41,2.93Z" />
        </svg>
    );
}